// import React, { useState } from 'react';
// import Modal from './Modal';
// import Partners from './partners';
// import { useNavigate } from 'react-router-dom';


// const Header = () => {
//   const [isTruckModalOpen, setTruckModalOpen] = useState(false);
//   const [isTrailerModalOpen, setTrailerModalOpen] = useState(false);

//   const openTruckModal = () => setTruckModalOpen(true);
//   const closeTruckModal = () => setTruckModalOpen(false);

//   const openTrailerModal = () => setTrailerModalOpen(true);
//   const closeTrailerModal = () => setTrailerModalOpen(false);

//   const navigate = useNavigate();
//   return (
//     <div className='bg-gradient-to-b from-gray-600 to-white'>
//       <header className="text-white p-4 flex justify-between items-center h-20 w-full">
//         {/* Company Name */}
//         <div className="text-2xl font-bold text-blue-600">
//           <a href="/" className="">Divine Trans Logistic</a>
//         </div>

//         <div className="flex space-x-8 relative">
          
//           <div className="relative group">
//             <button 
//               onClick={openTruckModal}
//               className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-500 hover:text-gray-200 hover:scale-125 transition-all hover:shadow-x1"
//             >
//               Book a Truck
//             </button>
//             <div className="absolute hidden group-hover:block bg-white text-black p-4 rounded mt-2 shadow-lg z-20">
//               <ul>
//                 <li className="py-1 px-4 hover:bg-gray-200 rounded"><a href="#">Truck size 1</a></li>
//                 <li className="py-1 px-4 hover:bg-gray-200 rounded"><a href="#">Truck size 2</a></li>
//                 <li className="py-1 px-4 hover:bg-gray-200 rounded"><a href="#">Truck size 3</a></li>
//               </ul>
//             </div>
//           </div>

//           {/* Book a Trailer Button */}
//           <div className="relative group">
//             <button 
//               onClick={openTrailerModal}
//               className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-500 hover:text-gray-200 hover:scale-125 transition-all hover:shadow-x1"
//             >
//               Book a Trailer
//             </button>
//             <div className="absolute hidden group-hover:block bg-white text-black p-4 rounded mt-2 shadow-lg z-20">
//               <ul>
//                 <li className="py-1 px-4 hover:bg-gray-200 rounded"><a href="#">Trailer size 1</a></li>
//                 <li className="py-1 px-4 hover:bg-gray-200 rounded"><a href="#">Trailer size 2</a></li>
//                 <li className="py-1 px-4 hover:bg-gray-200 rounded"><a href="#">Trailer size 3</a></li>
//               </ul>
//             </div>
//           </div>

//           {/* Other Links */}
          
//           <div className="relative group">
//             <button 
//               onClick={openTrailerModal}
//               className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-500 hover:text-gray-200 hover:scale-125 transition-all hover:shadow-x1"
//             >
//               Our Partners
//             </button>
//           </div>
//                     <div className="relative group">
//             <button 
//               onClick={openTrailerModal}
//               className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-500 hover:text-gray-200 hover:scale-125 transition-all hover:shadow-x1"
//             >
//               About us
//             </button>
//           </div>
//           <div className="relative group">
//             <button 
//               onClick={openTrailerModal}
//               className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-500 hover:text-gray-200 hover:scale-125 transition-all hover:shadow-x1"
//             >
//               Contact us
//             </button>
//           </div>
          
//         </div>

//         {/* Company Use Link */}
//         <div>
//           <a href="/company" className="bg-blue-500 text-white py-3 px-5 rounded hover:bg-green-500 hover:text-gray-200 hover:scale-125 transition-all duration-1000 delay-100 hover:shadow-x1">
//             For Company Use
//           </a>
//         </div>
//       </header>

//       {/* Modals */}
//       {isTruckModalOpen && <Modal onClose={closeTruckModal} bookingType="truck" />}
//       {isTrailerModalOpen && <Modal onClose={closeTrailerModal} bookingType="trailer" />}
//     </div>
//   );
// };

// export default Header;


// import React, { useState } from "react";
// import Modal from "./Modal";
// import { useNavigate } from "react-router-dom";

// const Header = () => {
//   const [isTruckModalOpen, setTruckModalOpen] = useState(false);
//   const [isTrailerModalOpen, setTrailerModalOpen] = useState(false);

//   const navigate = useNavigate();

//   return (
//     <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
//       <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">

//         {/* Logo */}
//         <div
//           onClick={() => navigate("/")}
//           className="text-xl font-semibold text-blue-600 cursor-pointer"
//         >
//           Divine Trans Logistic
//         </div>

//         {/* Navigation Links */}
//         <nav className="hidden md:flex items-center space-x-8 text-gray-600 font-medium">
//           <button
//             onClick={() => setTruckModalOpen(true)}
//             className="hover:text-blue-600 transition"
//           >
//             Book Truck
//           </button>

//           <button
//             onClick={() => setTrailerModalOpen(true)}
//             className="hover:text-blue-600 transition"
//           >
//             Book Trailer
//           </button>

//           <button
//             onClick={() => navigate("/partners")}
//             className="hover:text-blue-600 transition"
//           >
//             Partners
//           </button>

//           <button
//             onClick={() => navigate("/about")}
//             className="hover:text-blue-600 transition"
//           >
//             About
//           </button>

//           <button
//             onClick={() => navigate("/contact")}
//             className="hover:text-blue-600 transition"
//           >
//             Contact
//           </button>
//         </nav>

//         {/* CTA */}
//         <div>
//           <button
//             onClick={() => navigate("/company")}
//             className="bg-blue-600 text-white px-5 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition shadow-sm"
//           >
//             For Company Use
//           </button>
//         </div>
//       </div>

//       {/* Modals */}
//       {isTruckModalOpen && (
//         <Modal onClose={() => setTruckModalOpen(false)} bookingType="truck" />
//       )}
//       {isTrailerModalOpen && (
//         <Modal onClose={() => setTrailerModalOpen(false)} bookingType="trailer" />
//       )}
//     </header>
//   );
// };

// export default Header;


import React, { useState } from "react";
import Modal from "./Modal";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [isTruckModalOpen, setTruckModalOpen] = useState(false);
  const [isTrailerModalOpen, setTrailerModalOpen] = useState(false);

  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">

        {/* LOGO */}
        <div
          onClick={() => navigate("/")}
          className="text-xl font-semibold text-blue-600 cursor-pointer"
        >
          Divine Trans Logistic
        </div>

        {/* NAV LINKS */}
        <nav className="hidden md:flex items-center space-x-8 text-gray-600 font-medium">

          <button
            onClick={() => setTruckModalOpen(true)}
            className="hover:text-blue-600 transition"
          >
            Book Truck
          </button>

          <button
            onClick={() => setTrailerModalOpen(true)}
            className="hover:text-blue-600 transition"
          >
            Book Trailer
          </button>

          <button
            onClick={() => navigate("/partners")}
            className="hover:text-blue-600 transition"
          >
            Our Partners
          </button>

          <button
            onClick={() => navigate("/about")}
            className="hover:text-blue-600 transition"
          >
            About Us
          </button>

          <button
            onClick={() => navigate("/contact")}
            className="hover:text-blue-600 transition"
          >
            Contact Us
          </button>
        </nav>

        {/* CTA */}
        <button
          onClick={() => navigate("/company")}
          className="bg-blue-600 text-white px-5 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition"
        >
          For Company Use
        </button>
      </div>

      {/* MODALS */}
      {isTruckModalOpen && (
        <Modal onClose={() => setTruckModalOpen(false)} bookingType="truck" />
      )}
      {isTrailerModalOpen && (
        <Modal onClose={() => setTrailerModalOpen(false)} bookingType="trailer" />
      )}
    </header>
  );
};

export default Header;
